import { IconButton, Tooltip } from '@mui/material'
import React from 'react'
import InfoIcon from "@mui/icons-material/Info";


const CustomInfoIcon = ({message}) => {
  return (
    <>
       <Tooltip
            title={message}
            placement="bottom"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: '#fff',
                  color: '#000',
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  fontSize: '12px',
                  maxWidth: '400px',
                  maxHeight: '400px',
                  padding: '8px',
                  overflowY: 'auto',
                  '& .MuiTooltip-arrow': {
                    color: '#fff',
                    '&::before': {
                      border: '1px solid #ccc',
                    }
                  }
                }
              },
              arrow: {
                sx: {
                  color: '#fff',
                  '&::before': {
                    border: '1px solid #ccc',
                  }
                }
              }
            }}
          >
            <IconButton sx={{ p: 0.5, alignSelf: "flex-start", mt: 0.5 }}>
              <InfoIcon fontSize="small" style={{ width: "0.8em", color: "#1976d2" }} />
            </IconButton>
          </Tooltip>
    </>
  )
}

export default CustomInfoIcon
